import axios from '@/libs/api.request';

export const saveLiquidatedDamage = data => {
    return axios.request({
        url: 'api/preSaleManagement/liquidatedDamage/saveLiquidatedDamage',
        data: data,
        method: 'post'
    });
};
export const updateLiquidatedDamage = data => {
    return axios.request({
        url: 'api/preSaleManagement/liquidatedDamage/updateLiquidatedDamage',
        data: data,
        method: 'post'
    });
};
export const getLiquidatedDamageList = data => {
    return axios.request({
        url: 'api/preSaleManagement/liquidatedDamage/getLiquidatedDamageList',
        data: data,
        method: 'post'
    });
};
export const getLiquidatedDamageDetail = data => {
    return axios.request({
        url: 'api/preSaleManagement/liquidatedDamage/getLiquidatedDamageDetail',
        data: data,
        method: 'post'
    });
};
export const auditLiquidatedDamage = data => {
    return axios.request({
        url: 'api/preSaleManagement/liquidatedDamage/auditLiquidatedDamage',
        data: data,
        method: 'post'
    });
};
export const delLiquidatedDamage = data => {
    return axios.request({
        url: 'api/preSaleManagement/liquidatedDamage/delLiquidatedDamage',
        data: data,
        method: 'post'
    });
};
export const submitLiquidatedDamage = data => {
    return axios.request({
        url: 'api/preSaleManagement/liquidatedDamage/submitLiquidatedDamage',
        data: data,
        method: 'post'
    });
};
export const saveAndSubmitLiquidatedDamage = data => {
    return axios.request({
        url: 'api/preSaleManagement/liquidatedDamage/saveAndSubmitLiquidatedDamage',
        data: data,
        method: 'post'
    });
};
export const exportLiquidatedDamage = data => {
    return axios.request({
        url: 'api/preSaleManagement/liquidatedDamage/exportLiquidatedDamage',
        data: data,
        method: 'post'
    });
};

